import React from "react";
import { AppImage } from "../appMedia";
import thumbnailStyles from "./videoThumbnail.module.css";
import { TExercise } from "../../services/types/auth.types";

interface VideoThumbnailProps {
  exercise: TExercise;
  onClick: () => void;
}

const VideoThumbnail: React.FC<VideoThumbnailProps> = ({ exercise, onClick }) => {
  // Generate thumbnail URL for different video types
  const getThumbnailUrl = (videoUrl: string): string => {
    try {
      const url = new URL(videoUrl);
      
      // YouTube thumbnails
      if (url.hostname.includes('youtube.com') || url.hostname.includes('youtu.be')) {
        let videoId = '';
        
        if (url.hostname === 'youtu.be') {
          videoId = url.pathname.slice(1);
        } else if (url.searchParams.has('v')) {
          videoId = url.searchParams.get('v') || '';
        } else if (url.pathname.startsWith('/embed/')) {
          videoId = url.pathname.split('/')[2];
        }
        
        if (videoId) {
          return `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
        }
      }
      
      // Vimeo thumbnails would require API call, so we'll use a placeholder
      if (url.hostname.includes('vimeo.com')) {
        return ''; // Will fall back to placeholder
      }
      
      // For other video files, we'll use a placeholder
      return '';
    } catch {
      return '';
    }
  };

  const thumbnailUrl = getThumbnailUrl(exercise.link);

  return (
    <div className={thumbnailStyles.thumbnail} onClick={onClick}>
      <div className={thumbnailStyles.imageContainer}>
        {thumbnailUrl ? (
          <AppImage 
            src={thumbnailUrl} 
            alt={exercise.title}
            className={thumbnailStyles.image}
            onError={(e) => {
              // If thumbnail fails to load, hide the image and show placeholder
              (e.target as HTMLImageElement).style.display = 'none';
            }}
          />
        ) : null}
        
        <div className={thumbnailStyles.placeholder}>
          <div className={thumbnailStyles.playIcon}>▶</div>
        </div>
        
        <div className={thumbnailStyles.overlay}>
          <div className={thumbnailStyles.playButton}>
            <span className={thumbnailStyles.playButtonIcon}>▶</span>
          </div>
        </div>
      </div>
      
      <div className={thumbnailStyles.titleContainer}>
        <p className={thumbnailStyles.title}>{exercise.title}</p>
      </div>
    </div>
  );
};

export default VideoThumbnail;